import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const activationFunctionsComponent: ComponentDef = {
  id: 'activation-functions',
  name: 'Activation Functions',
  description: 'Parallel comparison of common activation functions: ReLU, GELU, SiLU, Swish.',
  category: 'function',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'variant', label: 'Variant', type: 'select', default: 'all', options: [{ label: 'All (comparison)', value: 'all' }, { label: 'ReLU', value: 'relu' }, { label: 'GELU', value: 'gelu' }, { label: 'SiLU/Swish', value: 'silu' }] }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const variant = params.variant;

    const g = new GraphBuilder();
    g.input('x', [seq_len, d_model]);

    if (variant === 'all') {
      g.activation('relu', 'x', 'ReLU');
      g.activation('gelu', 'x', 'GELU');
      g.activation('silu', 'x', 'SiLU');
      g.activation('swish', 'x', 'Swish');
      g.concat('out_cat', ['relu', 'gelu', 'silu', 'swish'], [seq_len, d_model * 4]);
      g.output('out', 'out_cat');
    } else if (variant === 'relu') {
      g.activation('out', 'x', 'ReLU');
      g.output('out', 'out');
    } else if (variant === 'gelu') {
      g.activation('out', 'x', 'GELU');
      g.output('out', 'out');
    } else {
      g.activation('silu', 'x', 'SiLU');
      g.mul('out', 'x', 'silu');
      g.output('out', 'out');
    }

    return g.build();
  }
};
